import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageState } from "@/components/common/PageState";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { getFrontdeskBlockForPath } from "@/constants/frontdeskPermissions";
import {
  hasFrontdeskBlockPermission,
  isCustomFrontDeskRole,
} from "@/utils/accessControl";

export const FrontdeskBlockGuard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { userProfile, isLoading } = useAuthenticatedUser();

  if (isLoading) return null;

  const block = getFrontdeskBlockForPath(pathname);
  if (
    isCustomFrontDeskRole(userProfile) &&
    block !== null &&
    !hasFrontdeskBlockPermission(userProfile, block)
  ) {
    return (
      <PageState
        tone="error"
        text={t("common.insufficientPermissions", "Insufficient permissions.")}
      />
    );
  }

  return <>{children}</>;
};
